export var encodeComponent = function(value) {
  return Object.entries(value).map(m => encodeURIComponent(m[0]) + '=' + encodeURIComponent(m[1])).join('&')
}
export var b64Encode = function(value) {
  return btoa(encodeURIComponent(value).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode('0x' + p1)))
}
// export async function sha256(value) {
//   return crypto.subtle.digest('SHA-256', new TextEncoder('utf-8').encode(value)).then(hash => {
//     return btoa(Array.from(new Uint8Array(hash)).map(byte => String.fromCharCode(byte)).join(''))
//   })
// }
